import React from 'react';
import { Tabs, Tab, Box, Button, Typography, TextField, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, MenuItem, Dialog, DialogTitle, DialogContent, Card } from '@mui/material';
import Client from '../Client';
import Config from '../ClientConfig';
import BackofficeReportsApi from './backofficeReportsApi';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

function formatIref(iref) {
  // Convert iref to string
  const irefStr = String(iref);
  // Calculate how many zeros to add to get length 7 (since 'K' is 1 char)
  const zerosNeeded = 7 - irefStr.length;
  // Create the zeros string
  const zeros = '0'.repeat(zerosNeeded > 0 ? zerosNeeded : 0);
  // Return concatenated string
  return 'K' + zeros + irefStr;
}

class PurchaseReceiptUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: new Client ( "none" ),
      tabIndex: 0,
      isSubmitting: false,
      purchaseOrders: [],
      productEntries: [],
      orderData: {
        type: '',
        documentDate: '',
        promisedDate: '',
        location: '',
        description: '',
        supplier: '',
        PurchaseOrderProductEntry_po: []
      },
      psiData: [],
      selectedSupplier: '',
      tabs: ['NIR List', 'New NIR'], 
      selectedOrder: null,
      showDetailDialog: false,
      selectedSupplierFilter: '',
      selectedLocationFilter: '',
      location: 0,
      locations: [{'iref': 0, 'name': "Select Location"}],
      supplier: 0,
      suppliers: [{'iref': 0, 'name': "Select Supplier"}]
    };
    
    this.getData = this.getData.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.fetchPurchaseOrders = this.fetchPurchaseOrders.bind(this);
  }

  componentDidMount() {
    this.fetchPurchaseOrders();
    this.getData ();
  }

  fetchPurchaseOrders = (locationId = null, supplierId = null) => {
    const queryData = {
      "type": 1,
    };
    if (locationId) {
      queryData.location = locationId;
    }
    if (supplierId) {
      queryData.supplier = supplierId;
    }
    let data = this.state.client.getData(Config.API_URL_PURCHASE_ORDERS, queryData);
    if ( data ) {
      let checks = [];
      if (Array.isArray(data)) {
        checks = data;
      } else if (Array.isArray(data.purchaseOrder)) {
      checks = data.purchaseOrder;
    } else if (data.purchaseOrder) {
      checks = [data.purchaseOrder];
    }

      this.setState({ purchaseOrders: checks });
    }
  };

  getData () {
    let psiData = this.state.client.getData(Config.API_URL_PRODUCT_SUPPLIER_INFO, {"active": 1});
    if (psiData) {
      this.setState({ psiData: psiData });
    }
    let queryData = {
      // "centralSupply": 0,
      "status": 2,
      "isPurchased": 1,
      "orderBy_name": 1,
      // "supplier": 2
    };
    let data = this.state.client.getData(Config.API_URL_PRODUCT, queryData);
    if (data && psiData) {
      const fullProductsMap = {};
      data.products.forEach(product => {
        fullProductsMap[product.iref] = product;
      });
      const quantityMultiplierMap = {};
      psiData.productSupplierInfo.forEach(info => {
        if (info.preferred) {  // or your preferred logic
          quantityMultiplierMap[info.product.iref] = info.quantityMultiplier;
        }
      });
      const products = data.products.filter(p => p.centralSupply === 0) || {};
      const productEntries = Object.keys(products).map((key, index) => {
        const fData = data.products[key];
        // console.log('product unitType:', fData.unitType);
        return {
          productId: fData.iref,     // might be duplicated
          productName: fData.name,
          unit: fData.unitType,
          inputQuantity: '',
          quantity: '',
          reactKey: `${fData.iref}-${key}`,
          quantityMultiplier: quantityMultiplierMap[fData.iref] ?? 1  // default 1 if none
        };
      });
      this.setState({ fullProductsMap, products, productEntries });
    }
    else {
      alert('Failed to load products.');
    }
  
    let locations = BackofficeReportsApi.getLocations(this.state.client);
    this.setState ( { locations: locations.locations });
  };

  handleLocationFilterChange = (e) => {
    const locationId = e.target.value;
    this.setState({ selectedLocationFilter: locationId }, () => {
      this.fetchPurchaseOrders(
        this.state.selectedLocationFilter,
        this.state.selectedSupplierFilter
      );
    });
  };
  handleSupplierFilterChange = (e) => {
    const supplierId = e.target.value;
    this.setState({ selectedSupplierFilter: supplierId }, () => {
      this.fetchPurchaseOrders(
        this.state.selectedLocationFilter,
        this.state.selectedSupplierFilter
      );
    });
  };

  selectLocation = (event) => {
    this.setState (
      {location: event.target.value},
      function(){
        this.handleOrderChange('location', event.target.value);
      }
    );
  }
  selectSupplier = (event) => {
    const supplierIref = event.target.value;
    this.setState(
      { selectedSupplier: supplierIref },
      () => {
        // Call any function you want after state update
        this.handleSupplierChange(supplierIref);
      }
    );
  };

  handleSupplierChange = (supplierIref) => {
    const filteredProducts = (this.state.psiData?.productSupplierInfo || [])
      .filter(item => {
        return (
          String(item.supplier?.iref) === String(supplierIref) &&
          (item.centralSupply === false || item.centralSupply === 0)
        );
      })
      .map(item => {
        const product = item.product;
        return {
          productId: product.iref,
          productName: product.name,
          unit: product.unitType ?? 0,
          quantityMultiplier: item.quantityMultiplier || 1, // ← fix is here
          inputQuantity: '',
          quantity: ''
        };
      })
      .sort((a, b) => a.productName.localeCompare(b.productName));
      
    this.setState({ productEntries: filteredProducts });
  };

  handleChange = (event, newValue) => {
    this.setState({ tabIndex: newValue });
  };

  handleOrderChange = (field, value) => {
    this.setState(prev => ({
      orderData: {
        ...prev.orderData,
        [field]: value,
      },
    }));
  };

  handleQuantityChange = (index, value) => {
    const productEntries = [...this.state.productEntries];
    const entry = productEntries[index];
    const v = String(value);                           // CHANGED
    // Allow intermediate states while typing: "", "-", trailing "." or ","
    if (v === '' || v === '-' || /[.,]$/.test(v)) {    // CHANGED
      entry.quantity = v;                               // CHANGED (keep as string temporarily)
    } else {
      if (Number(entry.unit) === 1) {
        // keep as string so trailing zeros are preserved while typing
        entry.quantity = v.replace(',', '.');
      } else {
        const n = parseFloat(v.replace(',', '.'));
        entry.quantity = isNaN(n) ? 0 : n;
      }
    }
    this.setState({ productEntries });
  }

  handleSubmit = () => {
    if (this.state.isSubmitting) return; 
    const { orderData, productEntries, selectedSupplier } = this.state;
    // Basic validation for required fields
    if (!orderData.promisedDate || !orderData.location) {
      alert('Please fill in both Date and Location before submitting.');
      return;  // stop submission
    }
    const filteredProducts = productEntries
      .filter(p => p.quantity && !isNaN(p.quantity) && parseFloat(p.quantity) !== 0)
      .map(p => ({
        product: p.productId,
        unit: p.unit,
        quantity: parseFloat(p.quantity)
      }));
      
    // Prevent submission if no valid lines
    if (filteredProducts.length === 0) {
      alert("Please enter at least one product line with quantity > 0.");
      return;
    }

    const now = new Date();
    const createdOn = now.toISOString();               // e.g. "2025-06-21T13:45:30.000Z"
    const type = 1;
    const supplier = selectedSupplier;

    const payload = {
      ...orderData,
      type,
      supplier,
      createdOn,
      PurchaseOrderProductEntry_po: filteredProducts
    };
    // console.log(JSON.stringify(payload));
    const result = this.state.client.pushData(Config.API_URL_PURCHASE_ORDERS, payload);
    if (result) {
      if (result && result.iref) {
        alert("NIR saved!");
        this.setState(prev => ({
          orderData: { type: 0, promisedDate: '', location: '', supplier: 0, description: '' },
          productEntries: prev.productEntries.map(p => ({ ...p, quantity: '', inputQuantity: '' })),
          location: 0,
          tabIndex: 0,
          isSubmitting: false
        }));
        this.fetchPurchaseOrders();
      } else {
        console.error('Save failed', result);
        const errorMessage = result.responseJSON?.message || "Save failed.";
        this.setState({ isSubmitting: false });
        alert(errorMessage);
      }
    } else {
      alert("Save failed: no response from server.");
    }

  };
  
  openOrderDetail = (po) => {
    this.setState({ selectedOrder: po, showDetailDialog: true });
  };

  closeOrderDetail = () => {
    this.setState({ showDetailDialog: false, selectedOrder: null });
  };

  renderNewOrderForm = () => {
    const { orderData, productEntries } = this.state;
    let locations = [{'iref': 0, 'name': "Select Location"}];
    if (this.state.locations){
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];
        let myData = {'iref': fData.iref, 'name': fData.name};
        locations.push ( myData );
      });
    }
    const unitTypeMap = { 0: 'pc', 1: 'kg' };
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');

    const minDateObj = new Date(today);
    minDateObj.setDate(minDateObj.getDate() - 30);
    const yyyyMin = minDateObj.getFullYear();
    const mmMin = String(minDateObj.getMonth() + 1).padStart(2, '0');
    const ddMin = String(minDateObj.getDate()).padStart(2, '0');
    const minDate = `${yyyyMin}-${mmMin}-${ddMin}`;

    const maxDate = `${yyyy}-${mm}-${dd}`;
    
    const localSuppliers = Object.values(
      (this.state.psiData?.productSupplierInfo || [])
        .filter(item => item.centralSupply === false)
        .reduce((acc, item) => {
          const id = item.supplier?.iref;
          if (id && !acc[id]) {
            acc[id] = item.supplier;
          }
          return acc;
        }, {})
    );
    let suppliers = [{ iref: 0, name: "Select Supplier" }, ...localSuppliers];
    const productSupplierInfo = this.state.psiData?.productSupplierInfo || [];
    const supplierProductIds = new Set(
      productSupplierInfo
        .filter(psi => String(psi.supplier?.iref) === String(this.state.selectedSupplier))
        .map(psi => psi.product.iref)
    );
    return (
      <Box sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Box sx={this.filterBarSx({ xs: '1fr 1fr', sm: '180px 220px 160px auto' })}>
          <TextField
            id="standard-select-location"
            select
            required
            label="Location"
            value={orderData.location || 0}
            variant="standard"
            size="small"
            sx={this.filterSx()}
            onChange={this.selectLocation}
          >
            {locations.map((option) => (
              <MenuItem key={option.iref} value={option.iref}>{option.name}</MenuItem>
            ))}
          </TextField>
          <TextField
            select
            variant="standard"
            required
            label="Supplier"
            value={this.state.selectedSupplier || 0}
            onChange={this.selectSupplier}
            size="small"
            sx={this.filterSx()}
          >
            {suppliers.map((supplier) => (
              <MenuItem key={supplier.iref} value={supplier.iref}>{supplier.name}</MenuItem>
            ))}
          </TextField>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Date"
                value={orderData.promisedDate ? dayjs(orderData.promisedDate) : null}
                onChange={(newValue) => {
                  const formattedDate = newValue ? newValue.format('YYYY-MM-DD') : '';
                  this.setState(prev => ({
                    orderData: {
                      ...prev.orderData,
                      documentDate: formattedDate,
                      promisedDate: formattedDate,
                    }
                  }));
                }}
                minDate={dayjs(minDate)}
                maxDate={dayjs(maxDate)}
                inputFormat="DD.MM.YYYY"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    size="small"
                    sx={this.filterSx()}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
                required
              />
          </LocalizationProvider>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }} />
        </Box>
          <TableContainer
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: 'auto',
            }}
          >
            <Table size="small" stickyHeader aria-label="new nir table">
              <TableHead>
                <TableRow>
                  <TableCell sx={this.headerCellSx('left', null, true)}><b>Product</b></TableCell>
                  <TableCell sx={this.headerCellSx('center', 48, true)}><b>Unit</b></TableCell>
                  <TableCell sx={this.headerCellSx('right', 116, true)}><b>Quantity</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productEntries
                  .filter(entry => supplierProductIds.has(entry.productId))
                  .map((entry, index) => (
                    <TableRow key={entry.reactKey || entry.productId}>
                      <TableCell sx={this.bodyCellSx('left', false, null, true)}>
                        {entry.productName}
                      </TableCell>
                      <TableCell sx={this.bodyCellSx('center', false, 48, true)}>
                        {unitTypeMap[entry.unit]}
                      </TableCell>
                      <TableCell sx={this.bodyCellSx('right', false, 116, true)}>
                        <TextField
                          type="text"
                          inputMode="text"  // <— full keyboard on iOS, still fine on Android
                          // pattern={entry.unit === 1 ? "^-?[0-9]+([.,][0-9]{0,3})?$" : "^-?[0-9]+$"}
                          value={String(entry.quantity ?? '')}

                          onKeyDown={(e) => {
                            // Let users add/remove "-" anytime (mobile often blocks it)
                            if (e.key === '-' || e.key === 'Minus' || e.key === 'Subtract') {
                              e.preventDefault();
                              const cur = String(entry.quantity ?? '').replace(',', '.');

                              if (cur === '' || cur === '-') {
                                // start with just "-" so they can continue typing
                                this.handleQuantityChange(index, '-');
                              } else if (cur.startsWith('-')) {
                                // make positive
                                this.handleQuantityChange(index, cur.slice(1));
                              } else {
                                // make negative
                                this.handleQuantityChange(index, '-' + cur);
                              }
                            }
                          }}

                          onChange={(e) => {
                            const raw = e.target.value;

                            if (Number(entry.unit) === 1) {
                              // allow negatives + optional [, or .] + up to 3 decimals (incl. trailing dot/comma)
                              if (/^-?\d*(?:[.,]\d{0,3})?$/.test(raw)) {
                                this.handleQuantityChange(index, raw.replace(',', '.'));
                              }
                            } else {
                              if (/^-?\d*$/.test(raw)) {
                                this.handleQuantityChange(index, raw);
                              }
                            }
                          }}

                          onBlur={(e) => {
                            let v = e.target.value.replace(',', '.');
                            if (v === '' || v === '-') return this.handleQuantityChange(index, '');
                            if (Number.isNaN(Number(v))) return;

                            if (Number(entry.unit) === 1) {
                              // ✅ keep text form, allow trailing zeros up to 3
                              const m = v.match(/^(-?\d+)(?:[.,](\d{0,3}))?$/);
                              if (m) {
                                const intPart = m[1];
                                const decPart = m[2] ?? '';
                                const out = decPart ? `${intPart}.${decPart}` : intPart;
                                this.handleQuantityChange(index, out);
                              }
                            } else {
                              // integers as before
                              const n = parseInt(v, 10);
                              if (!isNaN(n)) this.handleQuantityChange(index, String(n));
                            }
                          }}

                          inputProps={{
                            step: entry.unit === 1 ? '0.001' : '1', // kg: 0.001; pcs: 1
                            // inputMode: entry.unit === 1 ? 'decimal' : 'numeric',
                            style: { textAlign: 'right' },
                            pattern: Number(entry.unit) === 1
                              ? "^-?[0-9]+([.,][0-9]{0,3})?$"
                              : "^-?[0-9]+$",
                          }}

                          InputProps={{
                            sx: {
                              py: 0.2,
                              height: 34,
                              width: { xs: 78, sm: 110 },
                              fontSize: { xs: '16px', sm: '14px' },
                              backgroundColor: entry.unit === 1 ? '#e6f7ff' : 'inherit',
                            },
                          }}
                        />
                      </TableCell>
                      {/* <TableCell sx={{ py: 0.25, px: 0.5, width: '20%', whiteSpace: 'normal', textAlign: 'right' }}>
                        <TextField
                          type="number"
                          size="small"
                          value={entry.inputQuantity}
                          onChange={(e) => this.handleQuantityChange(index, e.target.value)}
                          inputProps={{
                            step: '0.001',
                            inputMode: 'decimal',
                            // min: 0,
                            style: { textAlign: 'right' },
                          }}
                          InputProps={{
                            sx: {
                              py: 0.2,
                              height: '32px',
                              width: '90px',
                              fontSize: '1rem',
                              backgroundColor: entry.quantityMultiplier > 1 ? '#fff3cd' : 'inherit',
                            },
                          }}
                        />
                      </TableCell> */}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              px: { xs: 1, sm: 1.5 },
              py: { xs: 1, sm: 1.25 },
              borderTop: '1px solid rgba(0,0,0,0.08)',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{ minWidth: { xs: '100%', sm: 220 }, px: 3 }}
              onClick={this.handleSubmit}
              disabled={this.state.isSubmitting}
            >
              Save NIR
            </Button>
          </Box>
      </Box>
    );
  };

  renderOrderList = () => {
    // console.log(this.state.purchaseOrders);
    let locations = [{'iref': 0, 'name': "Select Location"}];
    if (this.state.locations){
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];
        let myData = {'iref': fData.iref, 'name': fData.name};
        locations.push ( myData );
      });
    }
    const localSuppliers = Object.values(
      (this.state.psiData?.productSupplierInfo || [])
        .filter(item => item.centralSupply === false)
        .reduce((acc, item) => {
          const id = item.supplier?.iref;
          if (id && !acc[id]) {
            acc[id] = item.supplier;
          }
          return acc;
        }, {})
    );
    let suppliers = [{ iref: 0, name: "Select Supplier" }, ...localSuppliers];
    return (
      <Box sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Box sx={this.filterBarSx({ xs: '1fr 1fr', sm: '220px 260px auto' })}>
          <TextField
            id="standard-select-location-filter"
            select
            required
            label="Location"
            value={this.state.selectedLocationFilter || 0}
            variant="standard"
            size="small"
            sx={this.filterSx()}
            onChange={this.handleLocationFilterChange}
          >
            {locations.map((option) => (
              <MenuItem key={option.iref} value={option.iref}>{option.name}</MenuItem>
            ))}
          </TextField>
          <TextField
            select
            variant="standard"
            required
            label="Supplier"
            value={this.state.selectedSupplierFilter || 0}
            onChange={this.handleSupplierFilterChange}
            size="small"
            sx={this.filterSx()}
          >
            {suppliers.map((supplier) => (
              <MenuItem key={supplier.iref} value={supplier.iref}>{supplier.name}</MenuItem>
            ))}
          </TextField>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }} />
        </Box>
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <TableContainer
            sx={{
              height: '100%',
              overflow: 'auto',
            }}
          >
            <Table size="small" stickyHeader sx={{ tableLayout: 'fixed', width: '100%' }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={this.headerCellSx('center', 82)}><b>NIR</b></TableCell>
                  <TableCell sx={this.headerCellSx('left', 105)}><b>Date</b></TableCell>
                  <TableCell sx={this.headerCellSx('left')}><b>Location</b></TableCell>
                  <TableCell sx={this.headerCellSx('left')}><b>Supplier</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(this.state.purchaseOrders || []).map((po, idx) => (
                  <TableRow key={idx} hover onClick={() => this.openOrderDetail(po)} sx={{ cursor: 'pointer' }}>
                    <TableCell sx={this.bodyCellSx('center', false, 82)}>
                      {formatIref(po.iref)}
                    </TableCell>
                    <TableCell sx={this.bodyCellSx('left', false, 105)}>{po.documentDate}</TableCell>
                    <TableCell sx={this.bodyCellSx('left')}>{po.location?.name || po.location?.uid || '-'}</TableCell>
                    <TableCell sx={this.bodyCellSx('left')}>{po.supplier?.name || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    );
  };

  renderOrderDetailDialog = () => {
    const { selectedOrder } = this.state;
    if (!selectedOrder) return null;
    const unitTypeMap = { 0: 'pc', 1: 'kg' };
    return (
      <Dialog open={this.state.showDetailDialog} onClose={this.closeOrderDetail} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            m: 0,
            p: { xs: 1.5, sm: 2 },
            pr: 7,
            fontSize: { xs: '15px', sm: '18px' },
            fontWeight: 700,
          }}
        >
          NIR Detail - {formatIref(selectedOrder.iref || selectedOrder.id)}
          <IconButton
            aria-label="close"
            onClick={this.closeOrderDetail}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ px: { xs: 1.5, sm: 2 } }}>
          <Typography sx={this.dialogInfoSx()}>Date: {selectedOrder.documentDate}</Typography>
          <Typography sx={this.dialogInfoSx()}>NIR: {formatIref(selectedOrder.iref)}</Typography>
          <Typography sx={this.dialogInfoSx()}>Location: {selectedOrder.location?.name || '-'}</Typography>
          <Typography sx={this.dialogInfoSx()}>Supplier: {selectedOrder.supplier?.name || '-'}</Typography>

          {selectedOrder.PurchaseOrderProductEntry_po?.length > 0 && (
            <TableContainer sx={{ mt: 2, maxHeight: { xs: '65vh', sm: '70vh' }, overflow: 'auto' }}>
              <Table stickyHeader size="small" aria-label="nir detail table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={this.headerCellSx('left')}><b>Product</b></TableCell>
                    <TableCell sx={this.headerCellSx('center', 48)}><b>Unit</b></TableCell>
                    <TableCell sx={this.headerCellSx('right', 90)}><b>Quantity</b></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {[...selectedOrder.PurchaseOrderProductEntry_po]
                  .sort((a, b) => {
                    const nameA = this.state.fullProductsMap?.[a.product.iref]?.name || '';
                    const nameB = this.state.fullProductsMap?.[b.product.iref]?.name || '';
                    return nameA.localeCompare(nameB);
                  })
                  .map((line, idx) => {
                    const product = this.state.fullProductsMap?.[line.product.iref] || {};
                    return (
                      <TableRow key={idx}>
                        <TableCell sx={this.bodyCellSx('left')}>{product.name || line.product.iref || '-'}</TableCell>
                        <TableCell sx={this.bodyCellSx('center', false, 48)}>
                          {unitTypeMap[product.unitType] || '-'}
                        </TableCell>
                        <TableCell sx={this.bodyCellSx('right', true, 90)}>
                          {Number(line.quantity || 0).toLocaleString()}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
      </Dialog>
    );
  };

  render() {
    const { tabIndex, tabs } = this.state;

    return (
      <Card
        sx={{
          borderRadius: '14px',
          overflow: 'hidden',
          maxWidth: '100%',
          width: '100%',
          height: '100%',
          minHeight: 0,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ background: '#f6f4ef', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
          <Tabs
            value={tabIndex}
            onChange={this.handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              minHeight: { xs: 40, sm: 42 },
              px: { xs: 0.25, sm: 0.5 },
              '& .MuiTab-root': {
                minHeight: { xs: 42, sm: 44 },
                minWidth: 'auto',
                textTransform: 'none',
                fontWeight: 700,
                fontSize: { xs: '13px', sm: '14px' },
                px: { xs: 1.3, sm: 1.8 },
              },
            }}
          >
            {tabs.map((label, idx) => (
              <Tab key={idx} label={label} />
            ))}
          </Tabs>
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          {tabIndex === 0 ? this.renderOrderList() : this.renderNewOrderForm()}
        </Box>

        {this.renderOrderDetailDialog()}
      </Card>
    );
  }

  filterBarSx(gridTemplateColumns) {
    return {
      display: 'grid',
      gridTemplateColumns,
      gap: { xs: 1, sm: 1.25 },
      alignItems: 'end',
      px: { xs: 1, sm: 1.5 },
      py: { xs: 0.75, sm: 1 },
      borderBottom: '1px solid rgba(0,0,0,0.08)',
      flexShrink: 0,
    };
  }

  filterSx() {
    return {
      width: '100%',
      minWidth: 0,
      '& .MuiInputBase-input': { fontSize: { xs: '16px', sm: '14px' } },
      '& .MuiInputLabel-root': { fontSize: { xs: '13px', sm: '13px' } },
    };
  }

  dialogInfoSx() {
    return { fontSize: { xs: '13.5px', sm: '14px' }, mb: 0.25 };
  }

  headerCellSx(align, minWidth = null, compact = false) {
    return {
      padding: compact ? { xs: '8px 3px', sm: '7px 5px' } : { xs: '8px 7px', sm: '7px' },
      textAlign: align,
      whiteSpace: 'nowrap',
      minWidth,
      fontSize: { xs: '13px', sm: '13px', md: '14px' },
      backgroundColor: '#f6f4ef',
    };
  }

  bodyCellSx(align, strong = false, minWidth = null, compact = false) {
    return {
      padding: compact ? { xs: '8px 3px', sm: '7px 5px' } : { xs: '8px 7px', sm: '7px' },
      textAlign: align,
      whiteSpace: align === 'left' ? 'normal' : 'nowrap',
      minWidth,
      fontSize: { xs: '13.5px', sm: '13px', md: '14px' },
      fontWeight: strong ? 600 : 400,
      lineHeight: 1.35,
    };
  }
}

export default PurchaseReceiptUI;
